import { useListWorkspaces } from '@modusign/openapi-client-user';

import { useIsPublicWorkspace } from '@app/hooks/workspace';

const useIsPrivateWithPublicWorkspace = () => {
  const { data: hasPublicWorkspace } = useListWorkspaces({
    query: {
      select: (data) => data.workspaces.some((ws) => ws.type === 'PUBLIC'),
    },
  });

  const isPublicWorkspace = useIsPublicWorkspace();

  return hasPublicWorkspace && !isPublicWorkspace;
};

export default useIsPrivateWithPublicWorkspace;
